import { FC } from 'react';
import { Tag } from '@carbon/react';

interface Props {
  size?: 'sm' | 'md';
}

// The green "Edited" pill shown next to an edited field / card header / tree node.
// The system-edit variant returns with Story 4/7 (system-generated workspaces).
export const EditedPill: FC<Props> = ({ size = 'sm' }) => (
  <Tag type="green" size={size}>
    Edited
  </Tag>
);
